import Vue from 'vue';
import { MSEnum } from '@/common/enumeration';
import moment from 'moment';
//Import thủ công locale tiếng Việt — các locale khác đã bị IgnorePlugin loại khỏi bundle (xem vue.config.js)
import 'moment/locale/vi';
import i18nEnum from '@/i18n/vi/i18nEnum';
import DateRange from '@/components/msdaterange/DateRange';
import i18n from '@/i18n/i18n';
import Decimal from 'decimal.js';
import { commonFunction } from '@/common/commonFunction';

let numeral = require('numeral');
let mo = moment;
mo.locale('vi');
numeral.register('locale', 'vi', {
	delimiters: {
		thousands: '.',
		decimal: ','
	},
	abbreviations: {
		thousand: 'nghìn',
		million: 'triệu',
		billion: 'tỷ',
		trillion: 'nghìn tỷ'
	},
	ordinal: function(number) {
		return '.';
	},
	currency: {
		symbol: '' //'₫'
	}
});

// switch between locales
numeral.locale('vi');
/**
 * Xử lý convert từ string sang DateTime
 * @param {String} sDate Chuỗi cần parse
 * @author DNThang - 17.03.2020
 */
let parseStringToDate = function(sDate) {
	if (typeof sDate == 'string') {
		let dte = mo(value);
		if (!dte.isValid()) {
			dte = dte.toDate();
			return dte;
		}
	}
};

let msFormat = {
	/**
	 * Định dạng Time (theo format string truyền vào)
	 * @param {DateTime/String} value Giá trị cần format
	 * @param {String} formatString Định dạng cần trả ra sau khi format. Nếu không truyền thì sẽ lấy theo session.TimeFormat
	 * @author DNThang - 17.03.2020
	 */
	formatTime(value, formatString) {
		if (value) {
			let ret = value,
				dte = value;
			if (typeof dte == 'string') {
				dte = parseStringToDate(dte);
			}

			if (dte instanceof Date) {
				dte = mo(dte);
				if (dte.isValid()) {
					ret = dte.format(formatString);
				}
			}

			return ret;
		}
	},

	/**
	 * Format ngày tháng - trước mắt hỗ trợ dd/MM/yyyy
	 * Mặc định hỗ trợ định dạng YYYY-MM-DDTHH:mm:ss.SSSSZ (đây là format dữ liệu từ server)
	 * Bổ sung thêm hỗ trợ cho định dạng DD/MM/YYYY (do sử dụng từ )
	 * @param {Date/String} value
	 */
	formatDate(value) {
		if (!value) {
			return value;
		}
		if (typeof value == 'string') {
			value = value.replace('Z', '');
		}
		let ret,
			dte = value;

		if (!(dte instanceof Date)) {
			dte = mo(value);
			if (!dte.isValid()) {
				let dateFormat = 'DD/MM/YYYY';
				dte = mo(value, dateFormat.toUpperCase());
				if (!dte.isValid()) {
					throw new Error('DEV: value <' + value + '> format Date invalid.');
				}
			}

			dte = dte.toDate();
		}

		ret = dte.toLocaleDateString('vi', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});

		return ret;
	},
	format2Digit(value) {
		let num = Number(value);
		if (num == 0) {
			return '0';
		} else if (num < 10) {
			return '0' + num;
		} else {
			return num;
		}
	},
	formatDateTimeFull(value, formatDate = 'DD/MM/YYYY HH:mm:ss') {
		if (!value) {
			return value;
		}

		let ret,
			format = formatDate,
			dte = value;

		if (!(dte instanceof Date)) {
			dte = mo(value);
			dte = dte.toDate();
		}

		let m = mo(dte);
		ret = m.format(format);
		return ret;
	},

	formatEnum(value, enumName) {
		if (typeof value == 'number' || value || typeof value == 'boolean') {
			let formatValue = Number(value);
			if (Number.isNaN(formatValue)) {
				formatValue = value;
			}
			if (enumName) {
				let enumObj = MSEnum[enumName];
				if (enumObj) {
					if (!Object.keys(enumObj)) {
						return '';
					}
					let key = Object.keys(enumObj).find(k => enumObj[k] === formatValue);
					if (key) {
						let i18nEnumConfig = i18n.t('i18nEnum');
						let text = i18nEnumConfig[enumName][key];
						return text;
					} else {
						return formatValue;
					}
				} else {
					return formatValue;
				}
			} else {
				return formatValue;
			}
		}
	},
	/**
	 * Thực hiện định dạng số tiền quy đổi theo hệ thống
	 */
	formatAmount(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},

	/**
	 * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
	 */
	formatAmountOC(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},

	/**
	 * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
	 */
	formatAllocation(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},

	/**
	 * Thực hiện định dạng số lượng theo hệ thống
	 */
	formatQuantity(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},
	/**
	 * Thực hiện định dạng số lượng theo hệ thống
	 */
	formatExchangeRate(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},
	/**
	 * Thực hiện format định dạng đơn giá quy đổi
	 */
	formatUnitPrice(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},
	/**
	 * Thực hiện format định dạng đơn giá nguyên tệ
	 */
	formatUnitPriceOC(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}
		return result;
	},
	/**
	 * Thực hiện format định dạng số của hệ số/tỷ lệ
	 */
	formatCoefficient(num, options) {
		let result = num;
		if (options && options.zeroToEmpty && !num) {
			return null;
		}
		return result;
	},
	/**
	 * Thực hiện format kiểu số không có định dạng sau dấu chấm
	 */
	formatNumber(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null) {
			let digits = 0,
				buildDigits = 0;
			if (options && options.digits) {
				digits = options.digits;
			}

			//Xem ngôn ngữ là gì để format
			let localize = 'en-US';
			if (i18n.isVietnamese) localize = 'vi-VN';

			if (options && options.maxDigits) {
				const checkMinDigits = (num, options) => {
					if (options.minDigits && num && !Number.isInteger(num)) {
						return options.minDigits;
					}
					return 0;
				};
				result = Number(num).toLocaleString(localize, {
					style: 'decimal',
					minimumFractionDigits: checkMinDigits(num, options),
					maximumFractionDigits: options.maxDigits,
					useGrouping: true,
					minimumIntegerDigits: 1
				});
			} else {
				result = Number(num).toLocaleString(localize, {
					style: 'decimal',
					minimumFractionDigits: 0,
					maximumFractionDigits: buildDigits.toFixed(digits),
					useGrouping: true,
					minimumIntegerDigits: 1
				});
			}
		}
		//Convert dữ liệu NaN mặc định kết quả về 0
		if (result == 'NaN') return '0';
		return result;
	},

	formatNumberString(numStr, options) {
		if (!numStr) return 0;

		let result = new Decimal(numStr).toString();

		//Kiểm tra string(Định dạng số cứ lớn hơn hoặc bằng 18 số là js tự làm tròn "chạy thử trên chorme")
		if (!result || result.length < 18) {
			return msFormat.formatNumber(parseFloat(result), options);
		}

		//Đếm số lượng dấu . có trong chuỗi nếu lớn hơn 2 là sai định dạng hoặc không có giá trị thì thực hiện return
		let countDots = result.split('.');
		if (!countDots || countDots.length < 0 || countDots.length > 2) {
			return 0;
		}

		//Xem ngôn ngữ là gì để format
		let localize = 'en-US';
		if (i18n.isVietnamese) localize = 'vi-VN';

		// Tách phần nguyên và phần thập phân
		let [integerPart, decimalPart] = result.split('.');

		// Ghép lại phần nguyên và phần thập phân
		let formattedInteger = new Intl.NumberFormat(localize).format(integerPart);
		// Nếu có phần thập phân và maxDigit được truyền vào
		if (decimalPart && options && options.maxDigits >= 0) {
			// Làm tròn phần thập phân đến maxDigit, nhưng không thêm số 0 thừa
			decimalPart = parseFloat('0.' + decimalPart)
				.toFixed(options.maxDigits)
				.split('.')[1];

			// Nếu phần thập phân sau khi làm tròn không có chữ số thực, bỏ đi
			if (decimalPart.length < options.maxDigits) {
				decimalPart = decimalPart.replace(/0+$/, ''); // Loại bỏ các số 0 thừa ở cuối
			}
		}

		// Ghép lại phần nguyên và phần thập phân, dùng dấu phân cách phù hợp với locale
		const separator = localize === 'en-US' ? '.' : ','; // Tiếng Anh dùng dấu chấm, tiếng Việt dùng dấu phẩy
		// Ghép lại phần nguyên và phần thập phân
		return decimalPart ? `${formattedInteger}${separator}${decimalPart}` : formattedInteger;
	},

	/**
	 * format số âm theo cấu hình
	 */
	formatNegative(value) {
		return value;
	},
	/**
	 * Format định dạng số với kí tự ngăn cách trên tùy chọn theo báo cáo hoặc các form thường
	 * @param {Object} options : tùy chọn hệ thống
	 */
	formatSeperator(options) {
		// let seperator = {
		// 	decimalCharacter: session.GeneralDecimalSeparator,
		// 	digitGroupSeparator: session.GeneralGroupSeparator
		// };
		// if (options && options.isReport) {
		// 	seperator.decimalCharacter = session.GeneralDecimalSeparatorReport;
		// 	seperator.digitGroupSeparator = session.GeneralGroupSeparatorReport;
		// }
		// numeral.localeData().delimiters.decimal = seperator.decimalCharacter;
		// numeral.localeData().delimiters.thousands = seperator.digitGroupSeparator;
	},
	/**
	 * Join mảng thành chuỗi string theo dấu ;
	 */
	formatJoinString(value) {
		try {
			let arr = value;
			if (typeof value === 'string') {
				arr = JSON.parse(value);
			}
			if (Array.isArray(arr)) {
				return arr.join('; ');
			}
		} catch (error) {
			return '';
		}
	},
	formatGroup(value) {
		if (value) {
			return value.substring(1, value.length - 1);
		}
	},
	formatTaxPeriod(value) {
		if (value && value.startsWith('00/')) {
			if (value.startsWith('00/QT/')) {
				return value.substring(6, value.length);
			} else if (value.startsWith('00/CN/')) {
				return value.substring(6, value.length);
			} else {
				return value.substring(3, value.length);
			}
		}
		return value;
	},
	formatPassWord(value) {
		return '******';
	},
	formatEnumStatus(value, options) {
		if (typeof value == 'number' || value || typeof value == 'boolean') {
			let enumName = options.enumName;
			let formatValue = Number(value);
			if (Number.isNaN(formatValue)) {
				formatValue = value;
			}
			if (enumName) {
				let enumObj = MSEnum[enumName];
				if (enumObj) {
					if (!Object.keys(enumObj)) {
						return '';
					}
					let key = Object.keys(enumObj).find(k => enumObj[k] === formatValue);
					if (key) {
						let i18nEnumConfig = i18n.t('i18nEnum');
						let text = i18nEnumConfig[enumName][key];
						return text;
					} else {
						return formatValue;
					}
				} else {
					return formatValue;
				}
			} else {
				return formatValue;
			}
		}
	},
	formatRomanize(num) {
		let lookup = {
				M: 1000,
				CM: 900,
				D: 500,
				CD: 400,
				C: 100,
				XC: 90,
				L: 50,
				XL: 40,
				X: 10,
				IX: 9,
				V: 5,
				IV: 4,
				I: 1
			},
			roman = '',
			i;
		for (i in lookup) {
			while (num >= lookup[i]) {
				roman += i;
				num -= lookup[i];
			}
		}
		return roman;
	},
	num2WordVND(value, type) {
		var t = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'],
			donvi = function(r, n) {
				var o = '',
					a = Math.floor(r / 10),
					e = r % 10;
				return (
					a > 1
						? ((o = ' ' + t[a] + ' mươi'), 1 == e && (o += ' mốt'))
						: 1 == a
						? ((o = ' mười'), 1 == e && (o += ' một'))
						: n && e > 0 && (o = ' lẻ'),
					5 == e && a >= 1
						? (o += ' lăm')
						: 4 == e && a >= 1
						? (o += ' tư')
						: (e > 1 || (1 == e && 0 == a)) && (o += ' ' + t[e]),
					o
				);
			},
			hangtram = function(n, o) {
				var a = '',
					e = Math.floor(n / 100),
					n = n % 100;
				return o || e > 0 ? ((a = ' ' + t[e] + ' trăm'), (a += donvi(n, !0))) : (a = donvi(n, !1)), a;
			},
			hangtrieu = function(t, r) {
				var o = '',
					a = Math.floor(t / 1e6),
					t = t % 1e6;
				a > 0 && ((o = hangtram(a, r) + ' triệu'), (r = !0));
				var e = Math.floor(t / 1e3),
					t = t % 1e3;
				return e > 0 && ((o += hangtram(e, r) + ' nghìn'), (r = !0)), t > 0 && (o += hangtram(t, r)), o;
			};
		if (0 == value) return t[0];
		var n = '',
			a = '';
		do {
			let ty = value % 1e9;
			value = Math.floor(value / 1e9);
			n = value > 0 ? hangtrieu(ty, !0) + a + n : hangtrieu(ty, !1) + a + n;
			a = ' tỷ';
		} while (value > 0);
		if (type == 'USD') {
			return n.trim() + ' đô la Mỹ';
		} else {
			return n.trim() + ' đồng';
		}
	},
	formatFromNow(value, lang = 'vi') {
		if (!value) {
			return value;
		}

		mo.locale(i18n.locale);

		let ret,
			dte = value;

		if (!(dte instanceof Date)) {
			dte = mo(value);
			if (!dte.isValid()) {
				let dateFormat = 'DD/MM/YYYY';

				dte = mo(value, dateFormat.toUpperCase());
				if (!dte.isValid()) {
					throw new Error('DEV: value <' + value + '> format Date invalid.');
				}
			}
		}
		if (dte.fromNow) {
			ret = dte.fromNow();
		} else {
			dte = mo(value);
			ret = dte.fromNow();
		}
		if (ret) {
			ret = ret.replace('một', '1');
		}
		return ret;
	},

	cbxWithOrtherValue(value, options = {}) {
		if (
			(!value && value !== 0) ||
			(options.value === undefined ||
				options.value === null ||
				options.value == MSEnum.VatRate.KHAC ||
				options.value == 'KHAC')
		) {
			return '';
		}

		const formatVatRateOther = value => {
			let newValue = '';
			let isValueInteger = Number.isInteger(Number(value));
			// Là số nguyên
			if (isValueInteger) {
				newValue = `${value},00`;
			} else {
				newValue = value
					.toString()
					.replace('.', ',')
					.replace(/(\,\d{1}$)/, '$10');
			}
			return newValue;
		};

		//loại bỏ % ở cuối đi
		const removeTrailingPercent = value => {
			while (typeof value === 'string' && `${value}`.endsWith('%')) {
				value = `${value}`.slice(0, -1);
			}
			return value;
		};
		value = removeTrailingPercent(value);
		if (options && options.isValueOther) {
			return `KHAC: ${formatVatRateOther(value)}%`;
		}

		//Loại bỏ %
		if (value === 0 || value === '0' || value === '0%') {
			return `0%`;
		}

		const valueObj = MSEnum['VatRate'];
		var checkExistVatRateEnum = Object.keys(valueObj).find(key => valueObj[key] == value || key == value);
		if (value > 0) {
			//5,8,10
			if (checkExistVatRateEnum) return `${value}%`;
			return `${value}`;
		} else if (checkExistVatRateEnum && ['KCT', 'KKKNT', 'KTPVDC', 'KTGTT'].includes(checkExistVatRateEnum)) {
			return checkExistVatRateEnum;
		}

		return `${value}`;
	}
};

let caculate = {
	caculatePeriodNow(value) {
		let res = DateRange.caculatePeriodFromRange(new Date(value), new Date());
		let ret = msFormat.formatEnum(res, 'Period');
		return ret;
	}
};

Vue.filter('formatGroup', msFormat.formatGroup);
Vue.filter('formatTime', msFormat.formatTime);
Vue.filter('formatTimeFull', msFormat.formatTimeFull);
Vue.filter('formatDate', msFormat.formatDate);
Vue.filter('formatDateTimeFull', msFormat.formatDateTimeFull);
Vue.filter('formatEnum', msFormat.formatEnum);
Vue.filter('formatAmount', msFormat.formatAmount);
Vue.filter('formatAmountOC', msFormat.formatAmountOC);
Vue.filter('formatAllocation', msFormat.formatAllocation);
Vue.filter('formatQuantity', msFormat.formatQuantity);
Vue.filter('formatExchangeRate', msFormat.formatExchangeRate);
Vue.filter('formatUnitPrice', msFormat.formatUnitPrice);
Vue.filter('formatUnitPriceOC', msFormat.formatUnitPriceOC);
Vue.filter('formatCoefficient', msFormat.formatCoefficient);
Vue.filter('formatJoinString', msFormat.formatJoinString);
Vue.filter('formatNumber', msFormat.formatNumber);
Vue.filter('formatNumberString', msFormat.formatNumberString);
Vue.filter('formatTaxPeriod', msFormat.formatTaxPeriod);
Vue.filter('formatPassWord', msFormat.formatPassWord);
Vue.filter('formatEnumStatus', msFormat.formatEnumStatus);
Vue.filter('formatRomanize', msFormat.formatRomanize);
Vue.filter('formatFromNow', msFormat.formatFromNow);
Vue.filter('format2Digit', msFormat.format2Digit);
Vue.filter('num2WordVND', msFormat.num2WordVND);
Vue.filter('cbxWithOrtherValue', msFormat.cbxWithOrtherValue);
Vue.filter('formatCaculatePeriod', caculate.caculatePeriodNow);

/**
 * Xử lý format cho các kiểu số
 * CreatedBy PDKIEN 21/12/2019
 *
 */
Vue.filter('formatData', function(value, options = {}) {
	let result;
	let enumName = options.enumName;
	if (options.enumName && typeof options.enumName == 'function') {
		enumName = options.enumName(options.dataRow);
	}
	if (enumName && value != null) {
		let valueData = Number(value) || value;
		if (valueData || valueData == 0) {
			result = msFormat.formatEnum(valueData, enumName);
		} else {
			result = value;
		}
		return result;
	} else {
		switch (options.formatType) {
			case MSEnum.FormatType.ExchangeRate:
				result = msFormat.formatExchangeRate(value, options);
				break;
			case MSEnum.FormatType.GroupItem:
				result = msFormat.formatGroup(value);
				break;
			case MSEnum.FormatType.DateTime:
				result = msFormat.formatDateTimeFull(value);
				break;
			case MSEnum.FormatType.Time:
				result = msFormat.formatTime(value, options.formatString);
				break;
				break;
			case MSEnum.FormatType.Rate:
				result = msFormat.formatCoefficient(value, options);
				break;
			case MSEnum.FormatType.Join:
				result = msFormat.formatJoinString(value);
				break;
			case MSEnum.FormatType.UnitPrice:
				result = msFormat.formatUnitPrice(value, options);
				break;
			case MSEnum.FormatType.Amount:
				result = msFormat.formatAmount(value, options);
				break;
			case MSEnum.FormatType.UnitPriceOC:
				result = msFormat.formatUnitPriceOC(value, options);
				break;
			case MSEnum.FormatType.AmountOC:
				result = msFormat.formatAmountOC(value, options);
				break;
			case MSEnum.FormatType.Allocation:
				result = msFormat.formatAllocation(value);
				break;
			case MSEnum.FormatType.Quantity:
				result = msFormat.formatQuantity(value, options);
				break;
			case MSEnum.FormatType.Number:
				result = msFormat.formatNumber(value, options);
				break;
			case MSEnum.FormatType.NumberString:
				result = msFormat.formatNumberString(value, options);
				break;
			case MSEnum.FormatType.Date:
				result = msFormat.formatDate(value);
				break;
			case MSEnum.FormatType.TaxPeriod:
				result = msFormat.formatTaxPeriod(value);
				break;
			case MSEnum.FormatType.PassWord:
				result = msFormat.formatPassWord(value);
				break;
			case MSEnum.FormatType.VatRate:
				if (options && options.dataRow && options.dataFieldOther) {
					options = {
						isValueOther: options.dataRow[options.dataFieldOther],
						value: options.dataRow[options.dataField]
					};
				}
				result = msFormat.cbxWithOrtherValue(value, options);
				break;
			default:
				result = value;
				break;
		}
	}
	return result;
});

export default numeral;
export { msFormat };
